import type { FindMatchView } from '@minigame-race/contracts';
import type { MinigameProps } from '../../race/types.js';
import { FindMatchBoard } from '../../turn/FindMatchBoard.js';
import { TurnBoardFrame } from '../../turn/TurnBoardFrame.js';

/** Find Match as a race segment. See ConnectFourGame for the turn-adapter note. */
export function FindMatchGame({ view, emit }: MinigameProps) {
  const v = view as FindMatchView | null;
  if (!v) return null;
  return (
    <TurnBoardFrame>
      <FindMatchBoard view={v} onMove={emit} />
    </TurnBoardFrame>
  );
}
